import styled from 'styled-components';

export const ButtonSection = styled.div`
  width: 700px;
  margin: 48px auto 20px;
  display: flex;
  justify-content: space-between;
  .button-back {
    width: 115px;
    border: 2px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0px 1px 2px -1px #0000001a;
    box-shadow: 0px 1px 3px 0px #0000001a;
    background-color: white;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    color: #314158;
    @media (max-width: 767px) {
      width: auto;
    }
    @media (max-width: 365px) {
      font-size: 13px;
    }
  }
  .button-next {
    width: 185px;
    border: 2px solid transparent;
    background: linear-gradient(180deg, #296bcd 0%, #245499 100%);
    border-radius: 8px;
    box-shadow: 0px 4px 6px -4px #0000001a;
    box-shadow: 0px 10px 15px -3px #0000001a;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
    color: #ffffff;
    @media (max-width: 767px) {
      width: auto;
    }
    @media (max-width: 365px) {
      font-size: 13px;
    }
  }
  @media (max-width: 991px) {
    width: auto;
  }
`;
export const ButtonIcon = styled.img``;
export const Responsive = styled.div`
  @media (max-width: 991px) {
    display: flex;
    height: 100%;
    gap: 16px;
    .responsive-div {
      padding-right: 16px;
      flex: 1;
      overflow-y: scroll;
    }
  }
`;
